document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('#main-menu > .menu-item-has-children');
  const header = document.querySelector('header');
  const submenuBg = document.getElementById('submenu-bg');
  let hideTimeout;
  const activeSubmenus = new Set();

  menuItems.forEach((item) => {
    const toggle = item.querySelector('button.chevron');
    const toggleImages = item.querySelectorAll('button.chevron img');
    const submenu = item.querySelector('.sub-menu');

    let isClickedOpen = false;
    if (!submenu || !toggle) return;

    const closeSubmenu = () => {
      clearTimeout(hideTimeout);
      isClickedOpen = false;

      // Ensure submenu is visible so opacity transition works
      submenu.classList.remove('hidden');

      // Force reflow so browser registers the visibility change
      submenu.offsetHeight;

      // Start fade-out transition
      submenu.classList.remove('opacity-100');
      submenu.classList.add('opacity-0');
      toggleImages.forEach((img) => img.classList.remove('rotate-180'));
      activeSubmenus.delete(submenu); // ✅ Remove from active list
      updateSubmenuBg();

      setTimeout(() => {
        submenu.classList.add('hidden'); // Fully hide after fade
        toggle.setAttribute('aria-expanded', 'false');
      }, 300);
    };

    item.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        closeSubmenu();
      });
    });

    toggle.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent event from bubbling up to document

      isClickedOpen = !isClickedOpen;

      if (isClickedOpen) {
        submenu.classList.remove('hidden');
        setTimeout(() => {
          submenu.classList.remove('opacity-0');
          submenu.classList.add('opacity-100');
        }, 1);
        toggle.setAttribute('aria-expanded', 'true');
        toggleImages.forEach((img) => img.classList.add('rotate-180'));
        activeSubmenus.add(submenu);
        updateSubmenuBg(submenu);
      } else {
        closeSubmenu();
      }
    });
    // Close submenu when clicking elsewhere
    document.addEventListener('click', (e) => {
      if (!item.contains(e.target) && isClickedOpen) {
        return closeSubmenu();
      }
    });

    // Hover behavior
    item.addEventListener('mouseenter', () => {
      if (!isClickedOpen) {
        clearTimeout(hideTimeout);
        submenu.classList.remove('hidden');
        setTimeout(() => {
          submenu.classList.remove('opacity-0');
          submenu.classList.add('opacity-100');
        }, 1);
        toggleImages.forEach((img) => img.classList.add('rotate-180'));
        activeSubmenus.add(submenu);
        updateSubmenuBg(submenu);
      }
    });

    item.addEventListener('mouseleave', () => {
      if (!isClickedOpen) {
        submenu.classList.remove('opacity-100');
        submenu.classList.add('opacity-0');
        toggleImages.forEach((img) => img.classList.remove('rotate-180'));
        hideTimeout = setTimeout(() => {
          submenu.classList.add('hidden');
        }, 300);
        activeSubmenus.delete(submenu);
        updateSubmenuBg();
      }
    });

    function updateSubmenuBg() {
      let maxHeight = 0;
      let topOffset = 0;

      activeSubmenus.forEach((submenuEl) => {
        const rect = submenuEl.parentElement.getBoundingClientRect();
        const offsetTop = rect.bottom;
        const height = submenuEl.offsetHeight;

        if (height > maxHeight) {
          maxHeight = height;
          topOffset = offsetTop;
        }
      });

      if (maxHeight > 0) {
        submenuBg.style.top = `${topOffset}px`;
        submenuBg.style.height = `${maxHeight + 32}px`;
      } else {
        submenuBg.style.height = '0';
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');

  let lastScrollY = window.scrollY;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(() => {
        updateStyles();
        ticking = false;
      });
    }
  });

  const updateStyles = () => {
    const currentScrollY = window.scrollY;

    // Add scrolling class to header
    if (currentScrollY > 20) {
      header.classList.add('scrolling');
    } else {
      header.classList.remove('scrolling');
    }

    lastScrollY = currentScrollY;
  };
  // Initial update
  updateStyles();
});
